import { useLatestCell } from '@listening/frontend/hooks/use-latest-cell';
import { useEffect } from 'react';
import { webFollowGestureProps } from './follow-adapters';

export function useFollowGestureProps({
  getScrollElement,
  notifyUserScrollStart,
  notifyUserScrollEnd,
}: {
  readonly getScrollElement: () => HTMLDivElement | null;
  readonly notifyUserScrollStart: () => void;
  readonly notifyUserScrollEnd: () => void;
}) {
  const gestureEndTimer = useLatestCell<
    ReturnType<typeof setTimeout> | undefined
  >(undefined);
  const onUserGesture = () => {
    notifyUserScrollStart();
    clearTimeout(gestureEndTimer.get());
    gestureEndTimer.set(setTimeout(notifyUserScrollEnd, 250));
  };
  // Disarm the pending gesture-end timer on unmount so it can't fire into a
  // torn-down controller.
  useEffect(() => () => clearTimeout(gestureEndTimer.get()), [gestureEndTimer]);

  return webFollowGestureProps({ getScrollElement, onUserGesture });
}
